
// ======================================================================
// FILE:
// src/modules/finance/services/vendorLedgerService.js
//
// MODULE:
// Finance & Accounts Management System
//
// FEATURE:
// Vendor Ledger
//
// PURPOSE:
// Read-only API service for Vendor Ledger.
// ======================================================================

import axiosClient from "../../../api/axiosClient";

const BASE_URL = "/api/finance/payables";

// ======================================================================
// GET VENDOR LEDGER
// ======================================================================

async function getVendorLedger({
    vendorId,
    fromDate = "",
    toDate = "",
}) {
    if (!vendorId) {
        throw new Error("Please select a vendor.");
    }

    const response = await axiosClient.get(
        `${BASE_URL}/vendor-ledger`,
        {
            params: {
                vendor_id: vendorId,
                ...(fromDate && {
                    from_date: fromDate,
                }),
                ...(toDate && {
                    to_date: toDate,
                }),
            },
        }
    );

    if (!response.data?.success) {
        throw new Error(
            response.data?.message ||
            "Failed to load Vendor Ledger."
        );
    }

    return response.data.data;
}

// ======================================================================
// EXPORT
// ======================================================================

const vendorLedgerService = {
    getVendorLedger,
};

export default vendorLedgerService;
